import authAxios from 'src/modules/shared/axios/authAxios';

export default class EntitlementService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/entitlement/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(
      `/entitlement`,
      {
        params,
      },
    );

    return response.data;
  }

  static async unarchiveAll(ids) {
    const body = {
      ids,
    };

    const response = await authAxios.put(
      `/entitlement/unarchive`,
      body,
    );

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/entitlement`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/entitlement/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(
      `/entitlement/${id}`,
    );

    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/entitlement`, {
      params,
    });

    return response.data;
  }

  static async listAutocomplete(
    query,
    enterpriseOnly,
    limit,
  ) {
    const params = {
      query,
      enterpriseOnly,
      limit,
    };

    const response = await authAxios.get(
      `/entitlement/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }
}
